//@flow
import React from 'react'
import regionsMap from './images/popular.svg'
import './styles.scss'


export class Popular extends React.Component<Props, State> {
  constructor() {
    super()
    this.state = {
    }
    this.updateSizes = this.updateSizes.bind(this)
  }
  
  updateSizes() {
    this.setState({
      isMobile: window.innerWidth < 711
    })
  }
  
  componentDidMount() {
    window.addEventListener('resize', this.updateSizes)
    this.updateSizes()
  }

  render() {

    return <div className='popular'>
      <h3>Kleine Hunde gibt es am meisten</h3>
      <img src={regionsMap} alt='chart' />
      <div className="labels">
        <div className='one'>gross</div>
        <div className='two'>klein</div>
        <div className='three'>mittel</div>
        <div className='four'>sehr{this.state.isMobile&&(<br />)} gross</div>
      </div>
      <div className="hint">
        <div className='split'>
          <div className='left'>
            <div><b>klein:</b></div><div>unter 45 cm{this.state.isMobile&&(<br />)} und unter 15 kg</div>
            <div><b>mittel:</b></div><div>45–55 cm,{this.state.isMobile&&(<br />)} 15–25 kg</div>
          </div>

          <div className='right'>
            <div><b>gross:</b></div><div>55–70 cm,{this.state.isMobile&&(<br />)} 25–45 kg</div>
            <div><b>sehr gross:</b></div><div>über 70 cm{this.state.isMobile&&(<br />)} und über 45 kg</div>
          </div>
        </div>
      </div>
      <div className="source">Quelle: <a href='https://tierstatistik.identitas.ch/de/dogs-sizecategory.html'>Identitas</a></div>
    </div>
  }
}



             